/**
 * Constants for Thank You Component
 */
export enum ThankYouScenario {
  BothElectronic = 'bothElectronic',
  UimuiElectronicPipDeclined = 'uimuiElectronicPipDeclined',
  PipElectronicUimuiDeclined = 'pipElectronicUimuiDeclined',
  BothDeclined = 'bothDeclined',
  PipOnlyElectronic = 'pipOnlyElectronic',
  PipOnlyDeclined = 'pipOnlyDeclined',
  UimuiOnlyElectronic = 'uimuiOnlyElectronic',
  UimuiOnlyDeclined = 'uimuiOnlyDeclined'
}

// Default values
export enum DefaultTitle {
  Title = 'Thanks for choosing AIG',
}

export enum BothElectronic {
  Title = 'Thanks for choosing AIG and Thank You for Completing the UM/UIM and PIP Coverage Selection Forms',
  Content = 'Your Uninsured Motorists/Underinsured Motorists Coverage and Personal Injury Protection Coverage Selection Forms are now completed and signed. The forms are available by clicking "download documents" below.',
}

export enum UmUimElectronicPipDeclined {
  Title = 'Thanks for choosing AIG and Thank You for Completing the UM/UIM Coverage Selection Forms',
  Content = 'Your Uninsured Motorists/Underinsured Motorists Coverage Selection Forms are now completed and signed. The forms are available by clicking "download documents" below.',
  NonDigitalContent = 'You have opted out of electronic coverage selection for Personal Injury Protection Coverage. You have opted to receive the PIP coverage selection forms by download or by mail. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date',
}

export enum PipElectronicUimDeclined {
  Title = 'Thanks for choosing AIG and Thank You for Completing the UM/UIM and PIP Coverage Selection Forms',
  Content = 'Your Personal Injury Protection Coverage selection forms are now completed and signed. The forms are available by clicking "download documents" below.',
  NonDigitalContent = 'You have opted out of electronic coverage selection for Uninsured Motorists/Underinsured Motorists Coverage. You have opted to receive the UM/UIM coverage selection forms by download or by mail. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date.',
}

export enum BothDeclined {
  Title = 'Thanks for choosing AIG.',
  Content = 'You have opted out of electronic coverage selection for Uninsured Motorists/Underinsured Motorists Coverage and Personal Injury Protection Coverage. You have opted to receive the UM/UIM and PIP coverage selection forms by download or by mail. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date.',
}

export enum PipOnlyElectronic {
  Title = 'Thanks for choosing AIG.',
  Content = 'Your Personal Injury Protection Coverage Selection forms are all signed and available by clicking download documents below.',
}

export enum PipOnlyDeclined {
  Title = 'Thanks for choosing AIG.',
  Content = 'You have opted out of electronic coverage selection for Personal Injury Protection Coverage. You have opted to receive the PIP coverage selection forms by download or by mail. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date.'}

export enum UimuiOnlyElectronic {
  Title = 'Thank you for choosing AIG.',
  Content = 'Your Uninsured/Underinsured Motorist Coverage Selection forms are all signed and available by clicking download documents below.',
}

export enum UimuiOnlyDeclined {
  Title = 'Thanks for choosing AIG.',
  Content = 'You have opted out of electronic coverage selection for Uninsured Motorists/Underinsured Motorists Coverage. You have opted to receive the UM/UIM coverage selection forms by download or by mail. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date.',
}

// Common messages
export enum Messages {
  EmailConfirmation = 'An email confirmation of your elections has been sent to you.',
  CloseBrowserNote = 'You may close your browser to exit this process.',
  DocumentsUnavailableError = "We're unable to process your download request at this time. You will receive an email containing your completed forms when this issue is resolved.",
  PdfGenerationError = 'Error generating PDF:',
  ThankYouErrorMessage = 'Thank you page: Error fetching fresh request data:',
}

// File names
export enum FileNames {
  PipDocuments = 'PIP Documents.pdf',
  UiUimDocuments = 'UM/UIM Documents.pdf',
}
